"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _collapse = _interopRequireDefault(require("../../../../core/collapse"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _submit = _interopRequireDefault(require("../../../../core/submit"));
var _rowConfig = _interopRequireDefault(require("../../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../../core/label"));
var _col = _interopRequireDefault(require("../../../../core/col"));
var _input = _interopRequireDefault(require("../../../../core/input"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  newAdministrator: {
    administratorEmail: null,
    administratorName: null,
    notes: null
  },
  isOpened: false,
  isSubmitting: false
};
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "loading...");
var _ref2 = /*#__PURE__*/_react.default.createElement("div", {
  className: "card-header"
}, " New Administrator");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Email");
var _ref4 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Name");
var _ref5 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Note");
class NewAdministrator extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_toggleOpened", () => {
      this.setState({
        isOpened: !this.state.isOpened
      });
    });
    _defineProperty(this, "_setValue", (field, value) => {
      this.setState({
        newAdministrator: {
          ...this.state.newAdministrator,
          [field]: value
        }
      });
    });
    _defineProperty(this, "_cancelNewAdministrator", () => {
      this.setState(initialState);
    });
    _defineProperty(this, "_onSubmit", e => {
      e.preventDefault();
      this.setState({
        isSubmitting: true
      });
      this.props.onNewAdministrator(this.state.newAdministrator).then(() => {
        this.setState(initialState);
      });
    });
  }
  render() {
    if (!this.props.loaded) {
      return _ref;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginBottom: 8
      }
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._toggleOpened
    }, this.state.isOpened ? 'Hide New Administrator' : 'Add Administrator'), /*#__PURE__*/_react.default.createElement(_collapse.default, {
      isOpened: this.state.isOpened
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, _ref2, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this._onSubmit
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4,
        md: 3
      }, {
        sm: 8,
        md: 9
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "email",
      name: "administratorEmail",
      value: this.state.newAdministrator.administratorEmail,
      onChange: this._setValue.bind(this, 'administratorEmail'),
      maxLength: 100,
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref4, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "text",
      name: "administratorName",
      value: this.state.newAdministrator.administratorName,
      onChange: this._setValue.bind(this, 'administratorName'),
      maxLength: 100
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref5, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "text",
      name: "notes",
      value: this.state.newAdministrator.notes,
      onChange: this._setValue.bind(this, 'notes'),
      maxLength: 200
    })))), /*#__PURE__*/_react.default.createElement(_submit.default, {
      loading: this.state.isSubmitting
    }, "Save as New Administrator"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._cancelNewAdministrator
    }, " Cancel"))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = (0, _reactBicycle.connect)(NewAdministrator, undefined, (client, props) => ({
  onNewAdministrator(administrator) {
    administrator.competitionID = props.competitionID;
    return client.update('CompetitionAdministrator.create', administrator);
  }
}));